import Vue from 'vue';
import VueKindergarten from 'vue-kindergarten';
import Moment from 'moment';
import VeeValidate, { Validator } from 'vee-validate';
import nl from 'vee-validate/dist/locale/nl';

import ApiService from '@/common/api.service';
import FaService from '@/common/fa.service';
import JwtService from '@/common/jwt.service';

import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import child from '@/child';

import '@/registerServiceWorker';
import '@/components/globals';
import '@/styles/main.css';

Vue.config.productionTip = false;

Moment.locale('nl');
Vue.prototype.$moment = Moment;

// Localize takes the locale object as the second argument (optional) and merges it.
Validator.localize({ nl: nl });
Vue.use(VeeValidate, { inject: false, locale: 'nl', events: '' });

Vue.use(VueKindergarten, { child });

ApiService.init();
FaService.init();

const app = new Vue({
  router,
  store,
  render: h => h(App)
});

// Support Auth query param
const urlParams = new URLSearchParams(window.location.search);
const authParam = urlParams.get('auth');

if (authParam) {
  JwtService.saveToken({
    token_type: 'Bearer',
    expires_in: 900,
    access_token: authParam,
    refresh_token: '0'
  });
  window.location.href = window.location.origin + window.location.pathname;
}

router.onReady(() => {
  app.$mount('#app');
});
